import styled from "styled-components";

interface IIPhoneFrame {
    children?: any;
    style?: any;
}

const Container = styled.div`
    display: flex;
    
    .device,
    .device::before,
    .device::after,
    .device *,
    .device *::before,
    .device *::after {
        box-sizing: border-box;
        display: block;
    }

    .device {
        position: relative;
        transform: scale(1);
        z-index: 1;
    }

    .device .device-frame {
        z-index: 1;
    }

    .device .device-content {
        background-color: ${(props) => props.theme.colors.white};
        background-position: center center;
        background-size: cover;
        object-fit: cover;
        position: relative;
    }

    .device-iphone-x {
        height: 868px;
        width: 428px;
    }

    .device-iphone-x .device-frame {
        background: ${(props) => props.theme.colors.secondary};
        border-radius: 68px;
        box-shadow: inset 0 0 2px 2px #3A4245, inset 0 0 0 7px #3A4245;
        height: 868px;
        padding: 28px;
        width: 428px;
    }

    .device-iphone-x .device-content {
        border-radius: 40px;
        height: 812px;
        width: 375px;
    }

    .device-iphone-x .device-stripe::after,
    .device-iphone-x .device-stripe::before {
        border: solid rgba(51, 51, 51, .25);
        border-width: 0 7px;
        content: "";
        height: 7px;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: 9;
    }

    .device-iphone-x .device-stripe::after {
        top: 85px;
    }

    .device-iphone-x .device-stripe::before {
        bottom: 85px;
    }

    .device-iphone-x .device-header {
        background: ${(props) => props.theme.colors.secondary};
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        height: 30px;
        left: 50%;
        margin-left: -102px;
        position: absolute;
        top: 28px;
        width: 204px;
    }

    .device-iphone-x .device-header::after,
    .device-iphone-x .device-header::before {
        content: "";
        height: 10px;
        position: absolute;
        top: 0;
        width: 10px;
    }

    .device-iphone-x .device-header::after {
        background: radial-gradient(circle at bottom left, transparent 0, transparent 75%, #222 75%, #222 100%);
        left: -10px;
    }

    .device-iphone-x .device-header::before {
        background: radial-gradient(circle at bottom right, transparent 0, transparent 75%, #222 75%, #222 100%);
        right: -10px;
    }

    .device-iphone-x .device-sensors::after,
    .device-iphone-x .device-sensors::before {
        content: "";
        position: absolute;
    }

    .device-iphone-x .device-sensors::after {
        background: #444;
        border-radius: 3px;
        height: 6px;
        left: 50%;
        margin-left: -25px;
        top: 32px;
        width: 50px;
    }

    .device-iphone-x .device-sensors::before {
        background: #444;
        border-radius: 50%;
        height: 14px;
        left: 50%;
        margin-left: 40px;
        top: 28px;
        width: 14px;
    }

    .device-iphone-x .device-btns {
        background: ${(props) => props.theme.colors.secondary};
        height: 32px;
        left: -3px;
        position: absolute;
        top: 115px;
        width: 3px;
    }

    .device-iphone-x .device-btns::after,
    .device-iphone-x .device-btns::before {
        background: ${(props) => props.theme.colors.secondary};
        content: "";
        height: 62px;
        left: 0;
        position: absolute;
        width: 3px;
    }

    .device-iphone-x .device-btns::after {
        top: 60px;
    }

    .device-iphone-x .device-btns::before {
        top: 140px;
    }

    .device-iphone-x .device-power {
        background: ${(props) => props.theme.colors.secondary};
        height: 100px;
        position: absolute;
        right: -3px;
        top: 200px;
        width: 3px;
    }
`;

const IPhoneFrame: React.FC<IIPhoneFrame> = ({children, style}) => {
    return (
        <Container style={style}>
            <div className="device device-iphone-x">
                <div className="device-frame">{children}</div>
                <div className="device-stripe"></div>
                <div className="device-header"></div>
                <div className="device-sensors"></div>
                <div className="device-btns"></div>
                <div className="device-power"></div>
            </div>
        </Container>
    )
}

export default IPhoneFrame;
